// extracted by mini-css-extract-plugin
export default {"pill":"BgbyNTMdCopbqGRH2yUI","big":"keblDjhYNaSzvAC4Z9sY","highlight":"wO20pyIcn1IcU5OlZdYq","full":"k5I4cLQS8cPzei0cCxBZ"};